import _taggedTemplateLiteral from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject, _templateObject2, _templateObject3;

import styled from '@xstyled/styled-components';
import { styleVariables } from '@lib/common';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var AssignmentSummaryContainer = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  height: auto;\n  max-height: 200px;\n  background: ", ";\n  padding: 8px 72px 8px 72px;\n  border-radius: 16px;\n  border-top: 8px solid ", ";\n  box-shadow: 0px 3px 6px ", ";\n  overflow: scroll;\n  ::-webkit-scrollbar {\n    width: 0;\n  }\n"])), styleVariables.colors.gray1, styleVariables.colors.blue4, styleVariables.colors.transparentGray6);
var AssignmentSummaryTitle = styled.span(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  font-weight: 600;\n  font-size: 24px;\n  line-height: 80px;\n"])));
var AssignmentSummaryDescription = styled.p(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  font-weight: 300;\n  font-size: 16px;\n  line-height: 16px;\n"])));
export var SummaryAssignmentComponent = function SummaryAssignmentComponent(props) {
  var title = props.title,
      description = props.description,
      userName = props.userName;
  return /*#__PURE__*/_jsxs(AssignmentSummaryContainer, {
    children: [/*#__PURE__*/_jsx(AssignmentSummaryTitle, {
      children: title
    }), /*#__PURE__*/_jsxs(AssignmentSummaryDescription, {
      children: ["Mi\xEAu t\u1EA3: ", description]
    }), /*#__PURE__*/_jsxs(AssignmentSummaryDescription, {
      children: ["H\u1ECD v\xE0 t\xEAn: ", userName]
    })]
  });
};